// eslint-disable-next-line no-restricted-imports
import { Tag, Tooltip } from 'antd'
import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

import { getContrastColor } from '@/libs/utils'

type ShipmentCategoryLike = {
  name: string
  displayColor: string
}

type Props = ComponentPropsWithoutRef<'div'> & {
  shipmentCategory: ShipmentCategoryLike
  // 幅を切り詰めず全文表示したい場合に指定（未指定時は従来通り68px固定+truncate）
  width?: number | string
}

/**
 * 配送種別のTag
 */
export const ShipmentCategoryTag: FC<Props> = ({
  className,
  shipmentCategory,
  width = 68,
  ...props
}) => {
  return (
    <Tooltip
      title={shipmentCategory.name}
      mouseEnterDelay={0.3}
      placement="top"
    >
      <Tag
        {...props}
        className={clsx([
          'mr-0 !h-auto truncate rounded py-1 text-center text-[13px] leading-none',
          className
        ])}
        color={shipmentCategory.displayColor}
        style={{
          width,
          color: getContrastColor(shipmentCategory.displayColor)
        }}
      >
        {shipmentCategory.name}
      </Tag>
    </Tooltip>
  )
}
